import { render, staticRenderFns } from "./Predict.vue?vue&type=template&id=fd38ca06&scoped=true"
import script from "./Predict.vue?vue&type=script&lang=js"
export * from "./Predict.vue?vue&type=script&lang=js"
import style0 from "./Predict.vue?vue&type=style&index=0&id=fd38ca06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd38ca06",
  null
  
)

export default component.exports